// Navigation configuration for drawer/sider.
// The 'roles' is an arry of strings that indicate who can see this particular link.
// 'Any' is a local parameter only meant to include the link regardless of the roles
// (e.g. everyone can see the 'reports' page)
// Note -- the 'Admin' role sees EVERYTHING -- so no need to specify unless you're
// explicitly only allowing the 'Admin' to see a certain page.

import { NavItem } from '@models/nav-item';

export const NAV_DISPLAY: NavItem[] = [
  {
    title: 'Stories',
    icon: 'project',
    routerLink: '/ncx/stories-dashboard',
  },
  {
    title: 'Search',
    icon: 'search',
    routerLink: '/ncx/search-results',
  },
  {
    title: 'Activity',
    icon: 'block',
    routerLink: '/Activity',
    open: true,
    submenu: [
      {
        title: 'All',
        parent: 'Activity',
        routerLink: '/ncx/activity/:All',
      },
      {
        title: 'Hot',
        parent: 'Activity',
        routerLink: '/ncx/activity/:Hot',
      },
      {
        title: 'Standards',
        parent: 'Activity',
        routerLink: '/ncx/activity/:Standards',
      },
    ],
  },
  {
    title: 'Drafts',
    icon: 'file',
    routerLink: '/ncx/drafts',
  },
  {
    title: 'Groups',
    icon: 'team',
    routerLink: '/ncx/group-landing',
  },
  {
    title: 'Following',
    icon: 'star',
    submenu: [
      {
        title: 'Stories',
        parent: 'Following',
        routerLink: '/ncx/followed-stories',
      },
      {
        title: 'Connections',
        parent: 'Following',
        routerLink: '/ncx/connections',
      },
      {
        title: 'Topics',
        parent: 'Following',
        routerLink: '/ncx/topics',
      },
    ],
  },
  {
    title: 'Other Tools',
    icon: 'tool',
    routerLink: '/ncx/other-tools',
  },
  {
    title: 'Support',
    icon: 'question-circle',
    routerLink: '/ncx/support',
  },
  {
    title: 'Admin',
    icon: 'lock',
    routerLink: '/ncx-admin/landing',
    roles: ['Admin'],
  },
  {
    title: 'Settings',
    icon: 'setting',
    routerLink: '/ncx/settings',
  },
];
